import { useRuntimeConfig } from '#imports'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

export function useDisableCMSPromisePage() {
  const { market } = useMarketplace()
  const { FF_CMS_ENABLE_PROMISE_PAGE_COUNTRIES = '' } =
    useRuntimeConfig().public

  return !FF_CMS_ENABLE_PROMISE_PAGE_COUNTRIES.includes(market.countryCode)
}
